import Vuex from "vuex";
import axios from "axios";
import Vue from "vue";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        apiActions: {
            user: "",
            userValue: "",
            simulation: "",
            widgets: "",
        },
        datastore: {
            vueMybvk_userPackage_user: null,
            vueMybvk_userPackage_model: null,
            vueMybvk_userValPackage_user: null,
            vueMybvk_userValPackage_model: null,
            vueMybvk_simPackage_model: null,
            vueMybvk_presetData: null,
            vueMybvk_beitragstabelle: null,
            vueMybvk_einkaufstabelle: null,
            vueMybvk_municipalities: null,
            vueMybvk_widget: null,
        },
        userValuesFetched: false,
        userDataFetched: false,
        simulationDataFetched: false,
        historyFetched: false,
        userValuesLoading: false,
        userDataLoading: false,
        simulationDataLoading: false,
        historyLoading: false,
    },
    mutations: {
        setApiActions(state, apiActions) {
            state.apiActions = apiActions;
        },
        setLoadingData(state, data) {
            switch (data) {
                case "userData":
                    state.userDataLoading = true;
                    break;
                case "userValues":
                    state.userValuesLoading = true;
                    break;
                case "simulationData":
                    state.simulationDataLoading = true;
                    break;
                case "widgetData":
                    state.historyLoading = true;
                    break;
                default:
                    break;
            }
        },
        setUserData(state, data) {
            state.datastore.vueMybvk_userPackage_user = data.user;
            state.datastore.vueMybvk_userPackage_model = data.model;
            state.userDataFetched = true;
        },
        setUserValue(state, data) {
            state.datastore.vueMybvk_userValPackage_user = data.user;
            state.datastore.vueMybvk_userValPackage_model = data.model;
            state.userValuesFetched = true;
        },
        setSimulationData(state, data) {
            state.datastore.vueMybvk_simPackage_model = data.model;
            state.datastore.vueMybvk_presetData = data.constants;
            state.datastore.vueMybvk_beitragstabelle = data.beitragstabelle;
            state.datastore.vueMybvk_einkaufstabelle = data.einkaufstabelle;
            state.datastore.vueMybvk_municipalities = data.municipalities;
            state.simulationDataFetched = true;
        },
        setWidgetData(state, data) {
            state.datastore.vueMybvk_widget = data;
            state.historyFetched = true;
        },
        updateContributionStorage(state, { beitrag, mutationDate }) {
            let cp = { ...state.vueMybvk_simPackage_model };
            cp.beitragsvariante_wechsel = beitrag;
            cp.beitragsvariante_mutationsdatum = mutationDate;
            state.datastore.vueMybvk_simPackage_model = cp;
        },
        updateEinkaufStorage(state, { history, invoices }) {
            let cp = { ...state.vueMybvk_widget };
            cp.einkauf_history = history;
            cp.einkauf_invoices = invoices;
            state.datastore.vueMybvk_widget = cp;
        },
        updateScheidungStorage(state, { history, invoices }) {
            let cp = { ...state.vueMybvk_widget };
            cp.scheidungs_history = history;
            cp.scheidungs_invoices = invoices;
            state.datastore.vueMybvk_widget = cp;
        },
        updateWefStorage(state, { history, invoices }) {
            let cp = { ...state.vueMybvk_widget };
            cp.wef_history = history;
            cp.wef_invoices = invoices;
            state.datastore.vueMybvk_widget = cp;
        },
        clearStorage(state, dataType) {
            switch (dataType) {
                case "user":
                    state.userDataFetched = false;
                    break;
                case "value":
                    state.userValueFetched = false;
                    break;
                case "simulation":
                    state.simulationDataFetched = false;
                    break;
                case "widget":
                    state.historyFetched = false;
                    break;
                default:
                    break;
            }
        },
        resetStorage(state) {
            state.datastore.vueMybvk_userPackage_user = null;
            state.datastore.vueMybvk_userPackage_model = null;
            state.datastore.vueMybvk_userValPackage_user = null;
            state.datastore.vueMybvk_userValPackage_model = null;
            state.datastore.vueMybvk_simPackage_model = null;
            state.datastore.vueMybvk_presetData = null;
            state.datastore.vueMybvk_beitragstabelle = null;
            state.datastore.vueMybvk_einkaufstabelle = null;
            state.datastore.vueMybvk_municipalities = null;
            state.datastore.vueMybvk_widget = null;
            state.userDataFetched = false;
            state.userValuesFetched = false;
            state.simulationDataFetched = false;
            state.historyFetched = false;
        },
    },
    actions: {
        initializeApiActions({ commit }, data) {
            const apiActions = {
                user: data.user,
                userValue: data.userValue,
                simulation: data.simulation,
                widgets: data.widgets,
            };
            commit("setApiActions", apiActions);
        },
        async fetchUserData({ commit, state }) {
            if (state.userDataLoading) return Promise.resolve();
            commit("setLoadingData", "userData");
            const response = await axios.get(state.apiActions.user);
            commit("setUserData", response.data);
            return Promise.resolve();
        },
        async fetchUserValue({ commit, state }) {
            if (state.userValuesLoading) return Promise.resolve();
            commit("setLoadingData", "userValues");
            const response = await axios.get(state.apiActions.userValue);
            commit("setUserValue", response.data);
            return Promise.resolve();
        },
        async fetchSimulationData({ commit, state }) {
            if (state.simulationDataLoading) return Promise.resolve();
            commit("setLoadingData", "simulationData");
            const response = await axios.get(state.apiActions.simulation);
            commit("setSimulationData", response.data);
            return Promise.resolve();
        },
        async fetchWidgetData({ commit, state }) {
            if (state.historyLoading) return Promise.resolve();
            commit("setLoadingData", "widgetData");
            const response = await axios.get(state.apiActions.widgets);
            commit("setWidgetData", response.data);
            return Promise.resolve();
        },
        updateContributionStorage({ commit }, payload) {
            commit("updateContributionStorage", payload);
        },
        updateEinkaufStorage({ commit }, payload) {
            commit("updateEinkaufStorage", payload);
        },
        updateScheidungStorage({ commit }, payload) {
            commit("updateScheidungStorage", payload);
        },
        updateWefStorage({ commit }, payload) {
            commit("updateWefStorage", payload);
        },
        clearStorage({ commit }, dataType) {
            commit("clearStorage", dataType);
        },
        resetStorage({ commit }) {
            commit("resetStorage");
        },
    },
});
